import { request } from "./http";

export const listClients = () => request<import("../types").Client[]>("/api/clients");

export const createClient = (body: {
  name: string;
  phone?: string | null;
  email?: string | null;
  birth_date?: string | null;
  gender?: string | null;
  cpf?: string | null;
  zip?: string | null;
  street?: string | null;
  address_number?: string | null;
  complement?: string | null;
  neighborhood?: string | null;
  city?: string | null;
  state?: string | null;
  insurance?: string | null;
  plan?: string | null;
  card_number?: string | null;
  emergency_contact?: string | null;
  emergency_phone?: string | null;
}) =>
  request<import("../types").Client>("/api/clients", { method: "POST", body: JSON.stringify(body) });

export const updateClient = (
  id: number | string,
  body: Partial<{
    name: string;
    phone: string | null;
    email: string | null;
    birth_date: string | null;
    gender: string | null;
    cpf: string | null;
    zip: string | null;
    street: string | null;
    address_number: string | null;
    complement: string | null;
    neighborhood: string | null;
    city: string | null;
    state: string | null;
    insurance: string | null;
    plan: string | null;
    card_number: string | null;
    emergency_contact: string | null;
    emergency_phone: string | null;
  }>
) =>
  request<Partial<import("../types").Client>>(`/api/clients/${id}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });

export const deleteClient = (id: number | string) => request<void>(`/api/clients/${id}`, { method: "DELETE" });

export const getClient = (id: number | string) => request<import("../types").Client>(`/api/clients/${id}`);

export const listClientPayments = (clientId: number | string) =>
  request<import("../types").Payment[]>(`/api/clients/${clientId}/payments`);

export const listClientRecurringPlans = (clientId: number | string, params?: { include_inactive?: boolean }) =>
  request<import("../types").RecurringPlan[]>(`/api/clients/${clientId}/recurring-plans${params?.include_inactive ? '?include_inactive=1' : ''}`);

export const listClientContracts = (clientId: number | string) =>
  request<any[]>(`/api/clients/${clientId}/contracts`);

export const createClientContract = (clientId: number | string, body: { title: string; content: string }) =>
  request<any>(`/api/clients/${clientId}/contracts`, {
    method: "POST",
    body: JSON.stringify(body),
  });

export const deleteClientContract = (clientId: number | string, contractId: number | string) =>
  request<void>(`/api/clients/${clientId}/contracts/${contractId}`, { method: "DELETE" });

export const listClientTimeline = (clientId: number | string, params?: { limit?: number; offset?: number }) => {
  const search = params ? `?${new URLSearchParams({
    ...(params.limit && { limit: String(params.limit) }),
    ...(params.offset && { offset: String(params.offset) })
  })}` : '';
  return request<import("../types").TimelineEvent[]>(`/api/clients/${clientId}/timeline${search}`);
};

export const createTimelineEvent = (clientId: number | string, data: { content: string; event_type?: 'note' | 'call' | 'document' | 'other' }) =>
  request<import("../types").TimelineEvent>(`/api/clients/${clientId}/timeline`, {
    method: "POST",
    body: JSON.stringify(data),
  });

export const deleteTimelineEvent = (eventId: number | string) =>
  request<void>(`/api/timeline/${eventId}`, { method: "DELETE" });
